module.exports = __webpack_public_path__ + "static/media/church.ab4184fa.jpg";